import { ComponentsTranslation } from '@/assets/locales/components/components.translation.en';
import { dialogTranslations } from '@/assets/locales/components/dialog/dialog.translations.pl';
import { notificationsTranslations } from '@/assets/locales/components/notifications/notifications.translations.pl.ts';
import { tableTranslations } from '@/assets/locales/components/table/table.translations.pl';
import { formTranslation } from '@/assets/locales/form/form.translation.pl';

import { loaderWithInterestingFactsAboutAITranslations } from './loaderWithInterestingFactsAboutAI/loaderWithInterestingFactsAboutAI.translations.pl';

export const componentsTranslation: ComponentsTranslation = {
  chat: {
    documents: {
      attach: 'Załącz dokument',
      delete: 'Usuń',
      deleteDialog: {
        cancel: 'Anuluj',
        confirm: 'Usuń dokument',
        message: 'Czy na pewno chcesz usunąć ten dokument z czatu? Tej operacji nie można cofnąć.',
        title: 'Usuń dokument',
      },
      download: 'Pobierz',
      dropOverlay: 'Upuść plik, żeby go wgrać',
      dropzoneHintPrefix: 'Akceptowane: PDF, DOCX, XLSX, TXT · maks.',
      dropzoneLabel: 'Przeciągnij plik tutaj lub kliknij, żeby wgrać',
      dropzoneMaxSize: '20 MB / plik',
      embeddingStatus: {
        available: 'Dostępny w czacie',
        failed: 'Błąd przetwarzania',
        noContent: 'Brak treści do AI',
        processing: 'Przetwarzanie…',
      },
      empty: 'Brak dokumentów',
      hint: 'Asystent może korzystać z ich treści w tej rozmowie.',
      source: {
        activity: 'Aktywność rozwojowa',
        admin: 'Materiał administratora',
      },
      title: 'Dokumenty w tym czacie',
    },
    genericChatMessageBubble: {
      aiMessageHeader: 'jAIn',
      userMessageHeader: 'Ja',
    },
  },
  dialog: dialogTranslations,
  form: formTranslation,
  guidedJourney: {
    close: 'Zamknij na teraz',
    dontShowAgain: 'Nie pokazuj ponownie',
  },
  loaderWithInterestingFactsAboutAI: loaderWithInterestingFactsAboutAITranslations,
  notifications: notificationsTranslations,
  table: tableTranslations,
};
